<template>
  <div>
    <v-toolbar
      color="amber"
    >
      <div class="flex-grow-1"></div>

      <v-checkbox
        v-model="showOnlyConnected"
        label="Connected"
        class="mt-6 mr-3"
        @change="showOnlyConnectedChanged"
      >
      </v-checkbox>

      <v-checkbox
        v-model="showOnlyStaged"
        label="Staged"
        class="mt-6 mr-3"
        @change="showOnlyStagedChanged"
      >
      </v-checkbox>

      <div style="width: 250px;" class="pr-5">
        <v-text-field
          placeholder="filter state"
          single-line
          v-model="filterState"
          append-icon="filter_list"
          class="mt-4 mr-3"
          @input="filter"
        >
        </v-text-field>
      </div>

      <div style="width: 200px;" class="pr-5">
        <v-text-field
          placeholder="filter country code"
          single-line
          v-model="filterCountryCode"
          append-icon="filter_list"
          class="mt-4 mr-3"
          @input="filter"
        >
        </v-text-field>
      </div>
      <div style="width: 250px;" class="pr-5">
        <v-text-field
          placeholder="filter software version"
          single-line
          v-model="filterSoftwareVersion"
          append-icon="filter_list"
          class="mt-4 mr-3"
          @input="filter"
        >
        </v-text-field>
      </div>
      <div style="width: 300px;">
        <v-text-field
          placeholder="filter family"
          single-line
          v-model="filterFamily"
          append-icon="filter_list"
          class="mt-4 mr-3"
          @input="filter"
        >
        </v-text-field>
      </div>
      <div style="width: 300px;">
        <v-text-field
          placeholder="filter serial number"
          single-line
          v-model="filterSerialNumber"
          append-icon="filter_list"
          class="mt-4 mr-3"
          @input="filter"
        >
        </v-text-field>
      </div>
    </v-toolbar>

    <v-data-table
      class="mt-5"
      single-select
      :footer-props="{ disableItemsPerPage: true, showFirstLastPage: true, showCurrentPage: true  }"
      :headers="headers"
      :loading="busy"
      :items="aligners"
      :items-per-page="10"
      :server-items-length="serverItemsLength"
      :options.sync="options"
    >
      <template v-slot:item.softwareVersion="{ item }">
        <v-chip small :color="getVersionColor(item.softwareVersion, item.family)" dark>{{ item.softwareVersion }}</v-chip>
      </template>

      <template v-slot:item.updateVersion="{ item }">
        <v-chip v-if="item.updateVersion.length > 0" small :color="getVersionColor(item.updateVersion, item.family)" dark>{{ item.updateVersion }}</v-chip>
      </template>

      <template v-slot:item.flag="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <img class="mt-2" :src="getFlag(item)" v-on="on">
          </template>
          <span>{{item.geolocation.country_code}}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.staging.isStaged="{ item }">
        {{item.staging.isStaged ? (item.staging.autoStaged ? '(yes)' : 'yes') : 'no'}}
      </template>

      <template v-slot:item.connected="{ item }">
        {{item.connected ? 'yes' : 'no'}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';
import semver from 'semver';

export default {
  data() {
    return {
      headers: [
        {
          text: 'Serial Number',
          align: 'left',
          sortable: true,
          value: 'serialNumber',
          width: 175,
        },
        {
          text: 'Country',
          align: 'left',
          sortable: true,
          value: 'flag',
          width: 75,
        },
        {
          text: 'Family',
          align: 'left',
          sortable: true,
          value: 'family',
          width: 75,
        },
        {
          text: 'Current Version',
          align: 'left',
          sortable: true,
          value: 'softwareVersion',
          width: 175,
        },
        {
          text: 'Last Online At',
          align: 'left',
          sortable: false,
          value: 'lastSeenOnlineAt',
          width: 200,
        },
        {
          text: 'Staged',
          align: 'left',
          sortable: false,
          value: 'staging.isStaged',
          width: 100,
        },
        {
          text: 'Staged Version',
          align: 'left',
          sortable: false,
          value: 'staging.stagedVersion.semantic',
          width: 175,
        },
        {
          text: 'Staged At',
          align: 'left',
          sortable: true,
          value: 'staging.stagedAt',
          width: 200,
        },
        {
          text: 'Connected',
          align: 'left',
          sortable: true,
          value: 'connected',
          width: 100,
        },
        {
          text: 'State',
          align: 'left',
          sortable: true,
          value: 'bestGuessAtSoftwareUpdateState',
          width: 150,
        },
        {
          text: 'Update Version',
          align: 'left',
          sortable: true,
          value: 'updateVersion',
          width: 175,
        },
      ],
      options: {},
      busy: false,
      serverItemsLength: 0,
      aligners: [],
      showOnlyConnected: false,
      showOnlyStaged: false,
      filterState: '',
      filterCountryCode: '',
      filterSerialNumber: '',
      filterSoftwareVersion: '',
      filterFamily: '',
      aligner: {},
      serialNumber: '',
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    showOnlyConnectedChanged() {
      this.getData();
    },

    showOnlyStagedChanged() {
      this.getData();
    },

    getData() {
      const options = {
        method: 'get',
        url: `/read/updatescheduler_aligners_oasis/v1/?page=${this.options.page || 1}&filterSerialNumber=${this.filterSerialNumber}&filterCountryCode=${this.filterCountryCode}&filterSoftwareVersion=${this.filterSoftwareVersion}&filterFamily=${this.filterFamily}&filterState=${this.filterState}&sortBy=${this.options.sortBy || ''}&sortDesc=${this.options.sortDesc || false}&onlyConnected=${this.showOnlyConnected}&onlyStaged=${this.showOnlyStaged}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;

          console.log(JSON.stringify(res.data));

          this.aligners = res.data.docs.map((cur) => {
            const {
              createdAt, updatedAt, lastSeenOnlineAt, version, bestGuessAtSoftwareUpdateVersion, staging, ...rest
            } = cur;

            const {
              stagedAt, ...restStaging
            } = staging;

            const created = moment(createdAt);
            const updated = moment(updatedAt);
            const lastSeen = moment(lastSeenOnlineAt);
            const staged = stagedAt ? moment(stagedAt) : null;

            const softwareVersion = `${version.semantic}${version.meta ? ` - ${version.meta}` : ''}`;
            let updateVersion = {
              semantic: '',
              meta: '',
            };

            console.log(`${cur.serialNumber}: ${JSON.stringify(bestGuessAtSoftwareUpdateVersion)}`);

            if (rest.connected) {
              if ((bestGuessAtSoftwareUpdateVersion.semantic && bestGuessAtSoftwareUpdateVersion.semantic.length > 0)) {
                updateVersion = `${bestGuessAtSoftwareUpdateVersion.semantic}${bestGuessAtSoftwareUpdateVersion.meta ? ` - ${bestGuessAtSoftwareUpdateVersion.meta}` : ''}`;
              } else {
                updateVersion = '';
              }
            } else {
              rest.bestGuessAtSoftwareUpdateState = 'unknown';
              updateVersion = '';
            }
            console.log(`updateVersion: ${updateVersion}`);

            return Object.assign({}, {
              createdAt: created.local().format('YYYY-MM-DD HH:mm:ss'),
              updatedAt: updated.local().format('YYYY-MM-DD HH:mm:ss'),
              lastSeenOnlineAt: lastSeen.local().format('YYYY-MM-DD HH:mm:ss'),
              softwareVersion,
              updateVersion,
              staging: Object.assign({}, { stagedAt: staged ? staged.local().format('YYYY-MM-DD HH:mm:ss') : null }, restStaging),
            }, rest);
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    filter() {
      this.getData();
    },

    getVersionColor(version, family) {
      let color = 'green';

      if (version) {
        const v = version.split(' ')[0];

        if (family === 'aligner-oasis' && semver.gt(this.$store.state.latestOasisSoftwareVersion.semantic, v)) {
          color = 'red';
        } else if (family === 'gtps' && semver.gt(this.$store.state.latestGtpsSoftwareVersion.semantic, v)) {
          color = 'red';
        } else if (family === 'aligner' && semver.gt(this.$store.state.latestSoftwareVersion.semantic, v)) {
          color = 'red';
        }
      }

      return color;
    },

    getFlag(aligner) {
      if (aligner.geolocation) {
        return `/flags/${aligner.geolocation.country_code.toLowerCase()}.png`;
      }

      return '';
    },
  },
};
</script>
